import { render, staticRenderFns } from "./InventoryDetail.vue?vue&type=template&id=6e61fad8&"
import script from "./InventoryDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports